<template>
  <div>
    <b-modal
      v-if="isModal"
      id="login-modal"
      title="Login Account"
      centered
      :no-close-on-esc="true"
      :hide-footer="true"
      :no-close-on-backdrop="true"
    >
      <form method="POST" @submit.prevent="login">
      <p class="text-danger" v-if="isApiError">Invalid Credentials!</p>
      <p class="text-success" v-if="isLoginSuccess">{{ successMessage }}</p>
      <p class="text-danger" v-if="!$v.email.required">Email is required!</p>
      <p class="text-danger" v-if="!$v.email.email">Email is not valid!</p>
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-envelope"></i>
          </span>
        </div>
        <input
          type="email"
          class="form-control"
          placeholder="Email:"
          v-model.trim="$v.email.$model"
          required
        />
      </div>

      <p class="text-danger" v-if="!$v.password.required">Password is required!</p>
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-lock"></i>
          </span>
        </div>
        <input
          type="password"
          class="form-control"
          placeholder="Password:"
          v-model.trim="$v.password.$model"
          required
        />
      </div>
      <a v-b-modal.forgot-password class="text-primary ml-1"><small>Forgot password?</small></a>
      <button class="btn btn-primary float-right px-4" type="submit" :disabled="$v.$anyError">
        Login
        <ButtonLoader v-if="isLoading" />
      </button>
    </form>
    </b-modal>

    <form method="POST" @submit.prevent="login" v-else>
      <p class="text-danger" v-if="isApiError">Invalid Credentials!</p>
      <p class="text-success" v-if="isLoginSuccess">{{ successMessage }}</p>
      <p class="text-danger" v-if="!$v.email.required">Email is required!</p>
      <p class="text-danger" v-if="!$v.email.email">Email is not valid!</p>
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-envelope"></i>
          </span>
        </div>
        <input
          type="email"
          class="form-control"
          placeholder="Email:"
          v-model.trim="$v.email.$model"
          required
        />
      </div>

      <p class="text-danger" v-if="!$v.password.required">Password is required!</p>
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-lock"></i>
          </span>
        </div>
        <input
          type="password"
          class="form-control"
          placeholder="Password:"
          v-model.trim="$v.password.$model"
          required
        />
      </div>
      <a v-b-modal.forgot-password class="text-primary ml-1 text-xs"><small>Forgot password?</small></a>
      <button class="btn btn-primary float-right px-4" type="submit" :disabled="$v.$anyError">
        Login
        <ButtonLoader v-if="isLoading" />
      </button>
    </form>
    <ForgotPassword1 />
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { bookmarkMixin } from "@/mixins/bookmarkMixin";
import api from "@/api/axios";
import ForgotPassword1 from "../sharable/modals/authentication/ForgotPassword";

export default {
  props: {
    resource: {
      type: String,
      default: "login",
    },
    isModal: {
      type: Boolean,
      default: true,
    },
  },
  components: { ForgotPassword1 },
  data() {
    return {
      password: "",
      email: "",
      isLoading: false,
      isApiError: false,
      isLoginSuccess: false,
      successMessage: "",
      form: {},
      loginResource: ''
    };
  },
  mixins: [bookmarkMixin],
  validations: {
    password: {
      required,
    },
    email: {
      email,
      required,
    },
  },
  mounted() {
    this.loginResource = this.resource
    this.$eventBus.$off("open-login-modal");
    this.$eventBus.$on("open-login-modal", (params) => {
      this.loginResource = params;
      this.$bvModal.hide("login-as");
      this.$bvModal.show("login-modal");
    });
  },
  methods: {
    async login() {
      this.setInitialData();
      try {
        let { data } = await api.post(`authentication/supplier/login`, this.form);
        this.$store.dispatch("setUserData", data.data);
        localStorage.setItem("_token", data.data.token.access_token);
        localStorage.setItem("product_id", +this.$route.params.id);

        this.isLoading = false;
        this.isLoginSuccess = true;
        this.successMessage = "Success! You are now logged in...";

        setTimeout(() => {
          if (this.loginResource === "contact-supplier") {
            localStorage.setItem("open-contact-form", true);
            location.reload();
          } else if (this.loginResource === "login") {
            return (location.href = "/products");
          } else if (this.loginResource === "query") {
            return (location.href = "/query");
          } else if (this.loginResource === "bookmark-product") {
            location.reload();
          }
        }, 1500);
        localStorage.removeItem('login-redirect');
      } catch (error) {
        console.log(error, "error");
        this.isApiError = true;
        this.isLoading = false;
      }
    },
    setInitialData() {
      this.form.email = this.email;
      this.form.password = this.password;
      this.isLoading = true;
      this.isApiError = false;
      this.isLoginSuccess = false;
      this.successMessage = "";
    },
  },
};
</script>
